import { render, staticRenderFns } from "./other_types.vue?vue&type=template&id=690e5d44&scoped=true&"
import script from "./other_types.vue?vue&type=script&lang=js&"
export * from "./other_types.vue?vue&type=script&lang=js&"
import style0 from "./other_types.vue?vue&type=style&index=0&id=690e5d44&scoped=true&lang=scss&"
import style1 from "./other_types.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "690e5d44",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSlideGroup } from 'vuetify/lib/components/VSlideGroup';
import { VSlideItem } from 'vuetify/lib/components/VSlideGroup';
installComponents(component, {VSlideGroup,VSlideItem})


/* hot reload */
if (module.hot) {
  var api = require("/home/eu/public_ru/local/templates/international/int_site/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('690e5d44')) {
      api.createRecord('690e5d44', component.options)
    } else {
      api.reload('690e5d44', component.options)
    }
    module.hot.accept("./other_types.vue?vue&type=template&id=690e5d44&scoped=true&", function () {
      api.rerender('690e5d44', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/main/other_types.vue"
export default component.exports